import Vue from 'vue'
import VueRouter from 'vue-router'
import Login from '../views/Login.vue'
import Intro from '../views/Intro.vue'
import Photographs from '../views/Photographs.vue'
import PillPhotoBackgrounds from '../views/PillPhotoBackgrounds.vue'
import Backgrounds from '../views/Backgrounds.vue'
import PrintBackgrounds from '../views/PrintBackgrounds.vue'
import Flags from '../views/Flags.vue'
import Icons from '../views/Icons.vue'
import SelectorIcons from '../views/selectors/Icons.vue'
import SelectorPhotographs from '../views/selectors/Photographs.vue'
import SelectorBackgrounds from '../views/selectors/Backgrounds.vue'
import { store, mutations } from '../utils/store'

Vue.use(VueRouter)

const routes = [
  { path: '/', redirect: '/intro' },
  {
    path: '/login',
    name: 'Login',
    component: Login
  },
  {
    path: '/intro',
    name: 'Intro',
    component: Intro
  },
  {
    path: '/photographs/:categoryId?',
    name: 'photographs',
    component: Photographs,
    props: route => ({categoryId: route.params.categoryId })
  },
  {
    path: '/pill_photo_backgrounds/',
    name: 'pill_photo_backgrounds',
    component: PillPhotoBackgrounds,
  },
  {
    path: '/icons/:categoryId?',
    name: 'icons',
    component: Icons,
    props: route => ({categoryId: route.params.categoryId })
  },
  {
    path: '/flags/',
    name: 'flags',
    component: Flags,
  },
  {
    path: '/backgrounds/:categoryId?',
    name: 'backgrounds',
    component: Backgrounds,
    props: route => ({categoryId: route.params.categoryId })
  },
  {
    path: '/print_backgrounds/',
    name: 'print_backgrounds',
    component: PrintBackgrounds,
  },
  {
    path: '/selectors/photographs/:categoryId?',
    name: 'selector-photographs',
    component: SelectorPhotographs,
    props: route => ({categoryId: route.params.categoryId })
  },
  {
    path: '/selectors/icons/:categoryId?',
    name: 'selector-icons',
    component: SelectorIcons,
    props: route => ({categoryId: route.params.categoryId })
  },
  {
    path: '/selectors/backgrounds/:categoryId?',
    name: 'selector-backgrounds',
    component: SelectorBackgrounds,
    props: route => ({categoryId: route.params.categoryId })
  },  
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
  linkActiveClass: 'active'
})

router.beforeEach((to, from, next) => {
  if (to.query.token && to.name && to.name.match(/selector/)) {
    mutations.setQueryToken(to.query.token)
    next()
  }
  else if (to.name !== 'Login' && !store.token && !store.queryToken) next({ name: 'Login' })
  else next()
})


export default router
